/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import ContentLoader from "react-content-loader";
import { Box } from "@mui/material";

type LegalbirdLoaderProps = {
  centered?: boolean;
};

const LegalbirdLoader = ({ centered = true }: LegalbirdLoaderProps) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: centered ? "center" : "flex-start",
      alignItems: centered ? "center" : "flex-start"
    }}>
    <ContentLoader height={350} width={230} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
      <path d="m74.8 126.4c6.2-20.9 10.7-31.7-28-55.2-38.7-23.4-42.7-55.2-42.7-55.2-0.2 49.8 27 58.5 44.8 84 9.8 14.1 5.8 30.4 3.9 36 5.6-24-16.8-39.3-16.8-39.3-31.5-25.9-35.2-44.8-35.2-44.8-5.8 33.1 22.1 50 30.2 58.4 18.7 16.7 19.1 26.7 19.2 26.6 1.1 7.2-0.7 11-1.3 14.4-3.3-14.3-15.9-23.6-22.4-30-13.6-13.5-24.3-29.5-24.3-29.5-3.3 32 26.6 45 37.7 56.8 5.9 6.2 6.5 17.7 6.6 22.5 0.1 1.1 0.2 4.7 0.2 6.1-1.4-11-5.3-16.6-18.6-26.2-13.6-9.8-19.7-17.8-19.7-17.8 4.1 26.3 17.4 32.5 27.3 38.7 10 6.2 11.7 15.3 11.7 15.3v-0.3c0.5 4.8 1.4 9.3 2.4 13.5-4.7-5.7-10.2-8.8-13.3-10.9-7.6-5.5-18.5-15.6-18.5-15.6 9.1 28.3 38.7 53 47.7 61.2 0.8 0.9 1.8 1.8 1.8 1.8-0.2-0.4-0.5-1.1-0.8-1.6-17.1-34.9 3.8-94.3 8.1-108.9z" />
      <path d="m207.9 248.9s-3.6-22.3-48.1-11.7c0 0-60.1 7.2-59.9-30.1 0 0 1.2-66.9 6.5-107 5.4-40.1-58.3-42.5-100.7-100.1 0 0-14.5 39 41.3 75.1 25.6 16.6 46.8 24.8 43.3 35.2-15.2 44.9-19.3 86.9-19.3 86.9s-6.5 46.5 33.4 54.9c-41.3 2.2-57.9 15.3-61 17.6-8 6.3-20 16.2-25.4 24.7 0 0 12.7-8.3 89.3-21.1 50.6-9.3 99.7-18.7 111.4-1.4 0 0.1 4.1-13.9-10.8-23zm-15.9-1.2c-1.8 0.2-3.3-0.5-4.7-1.5-1.4-0.9-2.9-1.6-4.5-1.9 1.8 0.2 3.8-1 5.6-1.2 2-0.3 3.6 0.3 5.2 1.4 1.3 0.8 2.5 2.2 4 2.3-1.9-0.2-3.7 0.6-5.6 0.9z" />
    </ContentLoader>
  </Box>
);

export default LegalbirdLoader;
